import { gql } from "@apollo/client";

export const PARTNER_WALLET_HISTORY = gql`
  query (
    $operatorId: ID!
    $partnerId: ID
    $startDate: String
    $endDate: String
    $walletFilter: Int
    $walletId: Int
    $walletIds: [Int]
    $transactionNumber: String
    $walletTransactionTypeNo: Int
    $triggerTypeNo: Int
  ) {
    partnerWalletHistories(
      operatorId: $operatorId
      partnerId: $partnerId
      startDate: $startDate
      endDate: $endDate
      walletFilter: $walletFilter
      walletId: $walletId
      walletIds: $walletIds
      transactionNumber: $transactionNumber
      walletTransactionTypeNo: $walletTransactionTypeNo
      triggerTypeNo: $triggerTypeNo
    ) {
      walletTransactionId
      walletTransactionTypeNo
      transactionDate
      transactionAmount
      transactionCurrency
      debitWalletId
      debitWalletBalance
      debitAccountDetails {
        accountTypeNo
        accountId
        accountName
        walletId
      }
      creditWalletId
      creditWalletBalance
      creditAccountDetails {
        accountTypeNo
        accountId
        accountName
        walletId
      }
      triggerTypeNo
      appNo
      appReferenceId
      __typename
    }
  }
`;
